import styled from 'styled-components';

import { Color, FontWeight } from '../../../enums';
import { StyledComponent } from '../../../interfaces';
import { hexToRgba } from '../../../utils';

import { ContainerProps } from './tabButton.types';

export const Container: StyledComponent<'button', ContainerProps> = styled.button<ContainerProps>`
  height: 48px;
  min-width: 160px;
  background: ${({ $isActive }: ContainerProps): string => $isActive ? Color.Orange : Color.Transparent};
  border: ${({ $isActive }: ContainerProps): string => $isActive ? 'none' : `1px solid ${Color.Gray300}`};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 31px;
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${({ $isActive }: ContainerProps): string => $isActive ? Color.White : Color.Gray500};
  position: relative;

  &:hover {
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background: ${hexToRgba(Color.Black, 0.1)};
    }
  }
`;
